import { h } from './index-bb0e68fd.js';

const SvgIcon = (props) => (h("svg", { viewBox: "0 0 32 32", "aria-hidden": "true", class: props.classNames },
    h("use", { href: `#${props.name}` })));

export { SvgIcon as S };
